<template>
  <div class="client_container">
    <div class="mydia_div" v-if="collListStatus">
      <div
        :class="[
          $store.state.haveMessage
            ? 'mydia_div_header twinkling '
            : 'mydia_div_header',
        ]"
        :style="getNewMsgStyte()"
        @click="changeCsinfo"
      >
        <img
          :src="util.getLocalAccount().logoUrl"
          class="common-avatar"
          alt=""
        />
        <div class="mydia_header_info">
          <span class="mydia_header_title"> 我的对话 </span>
          <div
            class="mydia_header_status"
            :class="{
              onlinetip_color: Number(myUserStatus) === 1,
              busytip_color: Number(myUserStatus) === 2,
              leavetip_color: Number(myUserStatus) === 0,
            }"
          >
            {{ myStatusText }}
          </div>
        </div>
      </div>

      <div v-loading="loading" style="min-height: 60vh">
        <!-- v-if="!$store.state.hideOlc" -->
        <collegeTree
          ref="colTree"
          :label="tree.name"
          :nodes="tree.nodes"
          :depth="0"
          :type="tree.type"
        >
        </collegeTree>
      </div>
    </div>
    <div class="menu_div">
      <div class="menu_div_title">
        <div>
          {{
            this.$store.state.currentColleageInfo
              ? this.$store.state.currentColleageInfo.name + "的对话"
              : "我的对话"
          }}
        </div>
        <!-- {{collListStatus}} -->
        <img
          src="../../static/bar_right.png"
          :class="collListStatus ? 'telescoping-img1' : 'telescoping-img2'"
          @click="changeCollListStatus"
          class="telescoping-img"
        />
      </div>

      <div
        class="dialogueBox"
        style="min-height: 200px"
        ref="dialogueBox"
        v-loading="convSortLoading"
      >
        <div
          v-for="item in conversationList"
          :key="item.iType"
          class="dialogueBox-item"
        >
          <clientCollapse
            :iType="item.iType"
            :itemList="item.fn()"
            v-if="item.isShow()"
            @toList="clickItem"
          ></clientCollapse>
        </div>
      </div>
      <div style="flex: 1; background-color: #fff"></div>
    </div>
    <!--		<div style="width: 0.25rem;height: 100%;background: #E2E8F0;"></div>-->
    <div class="chat_mainbox">
      <default-chat
        v-if="
          (!$store.state.colleageAngle &&
            $store.state.selectedClient == null) ||
          ($store.state.colleageAngle &&
            $store.state.college.nowSelectClient == null)
        "
      >
      </default-chat>
      <home-chat
        v-else
        :userInfo="itemObj"
        :quickReply="quick"
        @setAdapter2="setAdapterAction2"
        @changeQuickReply="changeQuick"
      ></home-chat>
    </div>
  </div>
</template>

<script>
import defaultChat from "./defaultChat.vue";
import homeChat from "./homeChat.vue";
import clientCollapse from "./clientCollapse.vue";
import collegeTree from "./collegeTree.vue";
import Cookies from "js-cookie";
import Sortable from "sortablejs";
import {
  sendWebsocket,
  // connectWebsocket2,
  // closeWebsocket
} from "@/utils/websocket.js";
export default {
  name: "clientList",

  components: {
    defaultChat,
    homeChat,
    clientCollapse,
    collegeTree,
  },

  props: ["quick"],

  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "deptName",
        isLeaf: "leaf",
      },

      isNewClient: false,
      itemObj: null,
      isWork: false, //是否选中我的同事节点
      cancelCode: 2, //1-只发订阅 2-先发取消再发订阅 3-只发取消
      tree: {
        name: "我的同事",
        type: "4",
        nodes: [],
      },
      loading: false,
      scrollITop: true,

      // 临时存储上一同事信息
      tempColleague: null,
      timer: null,
      count: 0,
      clickTime: "",
      collListStatus: true,
      conversationList: [],
      convSortLoading: true,
      intervalId:'',
    };
  },

  computed: {
    colleageAngle() {
      console.log("clientList computed colleageAngle");
      return this.$store.state.colleageAngle;
    },

    collegeSelectClient() {
      console.log("clientList computed collegeSelectClient");
      return this.$store.state.college.nowSelectClient;
    },

    normalSelectClient() {
      console.log("clientList computed normalSelectClient");
      return this.$store.state.selectedClient;
    },

    isOnline() {
      return this.$store.state.isOnline;
    },
    resetWork() {
      return this.$store.state.resetWorkListStatus;
    },
    currentColleageInfo() {
      console.log(
        " this.$store.state.currentColleageInfo",
        this.$store.state.currentColleageInfo
      );
      return (
        this.$store.state.currentColleageInfo &&
        this.$store.state.currentColleageInfo.id
      );
    },
    myUserStatus() {
      const status = this.$store.state.authority.userStatus;
      if (status === undefined || status === null || status === "") {
        return 1;
      }
      return Number(status);
    },
    myStatusText() {
      const status = Number(this.myUserStatus);
      const time = this.$store.state.authority.timeLength;
      let name = "在线";
      if (status === 2) {
        name = "忙碌";
      } else if (status === 0) {
        name = "离开";
      }
      if (!time || time === "0秒") {
        return name + " 刚刚";
      }
      return name + time;
    },
  },

  created() {
    this.getDefaultSortOfCovList();
    console.log(
      "clientList created function selected = ",
      this.$store.state.selectedClient
    );
    if (this.$store.state.selectedClient !== null) {
      this.unreadCountRequest(this.$store.state.selectedClient);
    }
    setTimeout(() => {
      this.requestCollegeTree();
	}, 500);
   
    
  },
  mounted() {
    if (this.$nodeFs) {
      const ipc = this.$electron.ipcRenderer;
      ipc.send("getCookie");
      ipc.on("tio_session", (event, args) => {
        let res_obj = args.find((item) => {
          return item.name === "collListStatus";
        });
        if (res_obj) {
          this.collListStatus = res_obj.value === "show" ? true : false;
        } else {
          this.collListStatus = true;
        }
      });
    } else {
      const cookie_value = Cookies.get("collListStatus");
      console.log("**************", cookie_value);
      if (cookie_value) {
        this.collListStatus = cookie_value === "show" ? true : false;
      } else {
        this.collListStatus = true;
      }
    }

    Sortable.create(this.$refs.dialogueBox, {
      // handle: ".sheet-list",
      draggable: ".dialogueBox-item",
      filter: ".common-list",
      onUpdate: ({ newIndex, oldIndex }) => {
        console.log("newIndex, oldIndex：", newIndex, oldIndex);
        let temp = this.conversationList.splice(oldIndex - 1, 1)[0];
        this.conversationList.splice(newIndex - 1, 0, temp);
        this.updateDefaultSortOfCovList();
      },
    });

    this.clickTime = Date.now();
    this.contactsRequest(this.clickTime);
    if (this.$store.state.authority.isOnlineList == true) {
      console.log("线上列表函数触发");
      this.getOnlineList();
    }

    if (this.$store.state.authority.isOnlineOffList == true) {
      console.log("线上列表函数触发");
      this.getOnlineOffList();
    }

    window.addEventListener("storage", (e) => {
      if (e.key === "getLeavedList") {
        let csid = JSON.parse(localStorage.getItem("account")).id;
        console.log("clientList storage csid：", csid);
        this.getLeaveList(csid);
      } else if (e.key === "myColleagueIsShow") {
        console.log("clientList 监听storage myColleagueIsShow", e);
        if (e.newValue === "true") {
          this.requestCollegeTree();
        } else {
          this.requestCollegeTree();
          // this.tree.nodes = [];
          // this.$store.state.college.collegeTreeData = [];
        }
      }
    });
    if (!this.$store.state.colleageAngle) {
      console.log("骚扰列表");
      this.getHarass(this.util.getLocalAccount().id);
    }

    this.intervalId = setInterval(() => {
      if (this.$store.state.authority.isOnlineList == true) {
      console.log("线上列表函数触发");
      this.getOnlineList();
    }

    if (this.$store.state.authority.isOnlineOffList == true) {
      console.log("线上列表函数触发");
      this.getOnlineOffList();
    }
    }, 20000);
  },
  beforeDestroy() {
    // window.removeEventListener("online",this.onlineFun)
    // window.removeEventListener("offline",this.offlineFun)
    clearInterval(this.intervalId);
  },

  watch: {
    // myColleagueIsShow(newVal, oldVal) {
    //   console.log("clientList.vue watch newVal,oldVal:", newVal,oldVal);
    // },
    currentColleageInfo: {
      handler(newVal, oldVal) {
        if (this.timer) {
          console.log("一秒内重复点击同事执行最后一次");
          clearTimeout(this.timer);
        }
        this.count++;
        setTimeout(() => {
          if (this.count >= 2) {
            this.$message.error("请勿快速频繁点击客服对话列表");
          }
          this.count = 0;
        }, 1000);

        this.timer = setTimeout(() => {
          console.log("一秒内重复点击同事执行最后一次---------------------");
          console.log("clientList  watch currentColleageInfo newVal:", newVal);
          console.log("clientList  watch currentColleageInfo oldVal:", oldVal);
          // var el = this.$refs.clieneCollapseRef;
          // el.changeScrollTop();
          // el.noMore = false;
          // el.loading = false;
          // console.log("滚动元素的组件：", el);
          if (this.$store.state.colleageAngle) {
            if (oldVal !== null) {
              console.log("订阅------------------", 0, oldVal);
              this.sendType7(oldVal, 0);
            }
            if (newVal !== null) {
              console.log("订阅------------------", 1, newVal);
              this.sendType7(newVal, 1);
            }
          } else {
            console.log("订阅------------------", 0, oldVal);
            this.sendType7(oldVal, 0);
            this.tempColleague = oldVal;
          }
          if (this.$store.state.selectedClient) {
            this.$store.state.selectedClient.isChecked = false;
            this.$store.state.selectedClient = null;
          }
          if (this.$store.state.college.nowSelectClient) {
            this.$store.state.college.nowSelectClient.isChecked = false;
            this.$store.state.college.nowSelectClient = null;
          }
          if (newVal) {
            this.clickTime = Date.now();
            this.contactsRequest(this.clickTime);
          }
        }, 300);
      },
      deep: true,
    },
    isWork(newVal, oldVal) {
      console.log("clientList watch isWork new = ", newVal);
      console.log("clientList watch isWork old = ", oldVal);
      //由false变成true=>第一次点击同事
      if (newVal === true && oldVal === false) {
        this.cancelCode = 1;
      }
      //由true变成false=>离开我的同事
      if (newVal === false && oldVal === true) {
        this.isSendCancel = 3;
      }
    },

   

    collegeSelectClient(newVal, oldVal) {
      console.log("clientList watch collegeSelectClient newval = ", newVal);
      console.log(
        "clientList watch collegeSelectClient newval ===null ",
        newVal === null
      );
      console.log("clientList watch collegeSelectClient oldval = ", oldVal);
      var keyName = this.$store.state.keyName;
      if (keyName === "对话中" || keyName === "浏览中" || keyName === "在线访客列表") {
        if (this.$store.state.colleageAngle) {
          if (oldVal !== null) {
            console.log("同事订阅-------取消");
            console.log(
              "oldVal-----this.$store.state.selectedKey:",
              this.$store.state.selectedKey
            );
            this.$store.state.college.lastSelectClient = oldVal;
            this.sendType8(oldVal, 0);
          }
          if (newVal !== null) {
            console.log("同事订阅-------成功");
            console.log(
              "newVal -----this.$store.state.selectedKey:",
              this.$store.state.selectedKey
            );
            this.$store.state.selectedPath = 0;
            this.sendType8(newVal, 1);
          }
        } else {
          if (oldVal !== null) {
            console.log("同事订阅-------取消");
            this.sendType8(oldVal, 0);
            this.tempColleague = null;
          }
        }
      }
    },

    normalSelectClient(newVal, oldVal) {
      console.log("clientList watch normalSelectClient newval = ", newVal);
      console.log("clientList watch normalSelectClient oldVal = ", oldVal);
      if (oldVal) {
        oldVal.isChecked = false;
      }
      if (newVal !== null) {
        if (this.$store.state.selectedKey !== 3) {
          this.readCountRequest(newVal);
        }
      }

      if (oldVal !== null) {
        const iWsState = this.util.getLocalWsState();
        const iLogTip = this.util.getLoginTip();

        console.log("clientList normalSelectClient iWsState = ", iWsState);
        console.log("clientList normalSelectClient iLogTip = ", iLogTip);

        if (iWsState === "0" && iLogTip === "0") {
          return;
        }

        if (this.$store.state.selectedKey !== 3) {
          this.unreadCountRequest(oldVal);
        }
      }
    },

    isOnline(newVal, oldVal) {
      // console.log("newVal",newVal,"oldVal",oldVal)
      var self = this;
      if (newVal == true && oldVal == false) {
        setTimeout(() => {
          self.requestCollegeTree();
          // self.contactsRequest();
        }, 5000);
      }
    },

    resetWork(newVal, oldVal) {
      let self = this;
      if (newVal) {
        console.log("resetWork oldVal ", oldVal);
        self.requestCollegeTree();
        this.$store.state.resetWorkListStatus = false;
      }
    },
    colleageAngle(newVal) {
      const fn = {
        1: () => {
          return newVal
            ? this.$store.getters.csgetTalkingList
            : this.$store.getters.getTalkingList;
        },
        3: () => {
          return newVal
            ? this.$store.getters.csgetTalkedList
            : this.$store.getters.getTalkedList;
        },
        4: () => {
          return newVal
            ? this.$store.getters.csgetLeavedList
            : this.$store.getters.getLeavedList;
        },
      };
      const show = {
        6: () => {
          return newVal ? false : this.$store.state.authority.isTrouble;
        },
        7: () => {
          return newVal ? false : this.$store.state.authority.isOnlineList;
        },
        8: () => {
          return newVal ? false : this.$store.state.authority.isOnlineOffList;
        },
      };
      for (const item of this.conversationList) {
        item.fn = fn[item.iType] || item.fn;
        item.isShow = show[item.iType] || item.isShow;
      }

      console.log("clientList.vue watch colleageAngle:", this.conversationList);
    },
  },

  methods: {
    async getDefaultSortOfCovList() {
      const api = "/manager/sess/list/sort/listSessListSort";
      this.convSortLoading = true;
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      this.convSortLoading = false;
      console.log("clientList.vue getDefaultCovList res = ", res);
      if (res.resultCode !== "10000") {
        this.$message.error(res.desc);
      } else {
        this.conversationList = [];
        const conversationMap = {
          对话中: {
            fn: () => this.$store.getters.getTalkingList,
            iType: 1,
            isShow: () => true,
          },
          对话过: {
            fn: () => this.$store.getters.getTalkedList,
            iType: 3,
            isShow: () => true,
          },
          对话离开: {
            fn: () => this.$store.getters.getLeavedList,
            iType: 4,
            isShow: () => true,
          },
          骚扰会话: {
            fn: () => this.$store.getters.getTroubleList,
            iType: 6,
            isShow: () => this.$store.state.authority.isTrouble,
          },
          在线访客列表: {
            fn: () => this.$store.getters.getOnlineList,
            iType: 7,
            isShow: () => this.$store.state.authority.isOnlineList,
          },
          已离开: {
            fn: () => this.$store.getters.getOnlineOffList,
            iType: 8,
            isShow: () => this.$store.state.authority.isOnlineOffList,
          },
        };
        var pushSort = 0;
        for(let i = 0;i < 6; i++){
          var flag = false;
          res.data.forEach((item) => {
            const sort = item.sort;
            if(i + 1 == sort){
              flag = true;
            }
          });
          if(!flag){
            pushSort = i + 1;
          }
        }
        var it = {};
        it.sort = pushSort;
        it.name = '已离开';
        res.data.push(it);
        res.data.forEach((item) => {
          const index = item.sort - 1;
          const name = item.name;

          this.conversationList[index] = conversationMap[name];
          this.conversationList[index].name = name;
        });
      }
    },

    getNewMsgStyte() {
      console.log("newMsgColor ==" + this.$store.state.newMsgColor  );
      if (this.$store.state.newMsgColor == null || this.$store.state.newMsgColor == '') {
        this.$store.state.newMsgColor = "#ffe464";
      }
      var newMsgStyte =  this.$store.state.colleageAngle ? (this.$store.state.haveMessage ? this.$store.state.newMsgColor : "") : (this.$store.state.haveMessage ? this.$store.state.newMsgColor : "#e6f0fe");
      newMsgStyte = "background-color:" + newMsgStyte;
      console.log("newMsgStyte ==" + newMsgStyte );
      return newMsgStyte;
    },

    async updateDefaultSortOfCovList() {
      let sendObj = [];
      this.conversationList.forEach((item, index) => {
        sendObj.push({
          name: item.name,
          sort: index + 1,
        });
      });
      const api = "/manager/sess/list/sort/editSessListSort";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
        data: sendObj,
      });
      if (res.resultCode !== "10000") {
        this.$message.error(res.desc);
      }

      console.log("clientList.vue updateDefaultSortOfCovList res = ", res);
    },

    changeCollListStatus() {
      // this.collListStatus = !this.collListStatus;
      const be_value = this.collListStatus ? "hidden" : "show";
      if (this.$nodeFs) {
        const ipc = this.$electron.ipcRenderer;
        ipc.send("cookie", {
          name: "collListStatus",
          value: be_value,
          duration: 3153600000,
        });
        ipc.on("tio_session", (event, args) => {
          let res_obj = args.find((item) => {
            return item.name === "collListStatus";
          });
          if (res_obj) {
            this.collListStatus = res_obj.value === "show" ? true : false;
          } else {
            this.collListStatus = true;
          }
        });
      } else {
        document.cookie = `collListStatus=${be_value};Max-Age=3153600000`;
        this.collListStatus = !this.collListStatus;
      }
    },
    sendType7(obj, iStatus) {
      console.log("clientList sendType7 status = ", iStatus);
      console.log("clientList sendType7 obj = ", obj);
      const account = this.util.getLocalAccount();
      const token = this.util.getLocalToken();
      const type7Msg = {
        type: "7",
        token: token,
        data: {
          status: iStatus,
          csid: account.id,
          c_csid: obj,
        },
      };
      console.log("clientList sendType7 type8Msg = ", type7Msg);

      sendWebsocket(type7Msg, this.wsMessage, this.wsError);
    },
    changeCsinfo() {
      if (this.$store.state.colleageAngle) {
        this.$store.state.haveMessage = false;
        this.$nextTick(() => {
          this.$store.commit("changeBg", null);
          this.$store.commit("changeColleageAngle", false);
        });
      }
    },

    sendType8(obj, iStatus) {
      console.log("clientList sendType8 status = ", iStatus);
      console.log("clientList sendType8 obj = ", obj);
      console.log(
        "clientList sendType8 this.tempColleague = ",
        this.tempColleague
      );
      const account = this.util.getLocalAccount();
      const token = this.util.getLocalToken();
      const type8Msg = {
        type: "8",
        token: token,
        data: {
          status: iStatus,
          sid: obj.sid,
          csid: account.id,
          c_csid: this.tempColleague
            ? this.tempColleague
            : this.$store.state.currentColleageInfo.id,
        },
      };

      console.log("clientList sendType8 type8Msg = ", type8Msg);

      sendWebsocket(type8Msg, this.wsMessage, this.wsError);
    },

    sendTyp8(obj, iStatus) {
      console.log("clientList sendType8 status = ", iStatus);
      console.log("clientList sendType8 obj = ", obj);
      console.log(
        "clientList sendType8 this.tempColleague = ",
        this.tempColleague
      );
      const account = this.util.getLocalAccount();
      const token = this.util.getLocalToken();
      const type8Msg = {
        type: "8",
        token: token,
        data: {
          status: iStatus,
          sid: obj.sid,
          csid: account.id,
          c_csid: obj.csid,
        },
      };

      console.log("clientList sendType8 type8Msg = ", type8Msg);

      sendWebsocket(type8Msg, this.wsMessage, this.wsError);
    },

    // ws连接成功，后台返回的ws数据，组件要拿数据渲染页面等操作
    wsMessage(data) {
      console.log("homeChat wsMessage");
      if (data === undefined) {
        return;
      }
    },

    // ws连接失败，组件要执行的代码
    wsError() {
      // 比如取消页面的loading
      console.log("homeChat wsError");
    },

    async readCountRequest(obj) {
      console.log("clientList readCountRequest obj = ", obj);
      var api = "/manager/session/sessmsg/readed/" + obj.sid;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });

      console.log("clientList readCountRequest response = ", response);
      if (response.resultCode !== "10000") {
        this.$message.error(response.desc);
      }
    },

    async unreadCountRequest(obj) {
      console.log("clientList unreadCountRequest obj = ", obj);

      var api = "/manager/session/leave/chat/" + obj.sid;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });

      console.log("clientList unreadCountRequest response = ", response);
      if (response.resultCode !== "10000") {
        this.$message.error(response.desc);
      }
    },

    async getCountRequest() {
      console.log("clientList getCountRequest");
      var api = "/manager/session/colleague/colleagueCount";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });

      console.log("clientList getCountRequest response = ", response);
      if (response.resultCode === "10000") {
        this.$store.state.colleagueNum = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },

    async requestCollegeTree() {
      console.log("clientList requestCollegeTree  this.$store.state.authority.isColleague=",this.$store.state.authority.isColleague);
      if (!this.$store.state.authority.isColleague) {
        return;
      }
      this.loading = true;
      console.log("clientList requestCollegeTree  this.$store.state.authority.isColleague=",this.$store.state.authority.isColleague);
      var api = "/manager/session/colleague/list";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      if (response.resultCode === "10000") {
        const res = response.data;
        if (res) {
          var temp = res.list[0].nodes;
          console.log("response-------------", res);
          if (temp !== null) {
            arraySort(temp);
          }
          this.tree.nodes = res.list;
          this.$store.state.college.collegeTreeData = res.list;
          this.$store.state.hideOlc = res.hideOlc;
          const localType28 = localStorage.getItem("type28Data");
          console.log("localType28 = ", localType28);
          console.log("this.$store.state.hideOlc ", this.$store.state.hideOlc);
          if (localType28 !== null && localType28.length > 0) {
            const type28data = JSON.parse(localStorage.getItem("type28Data"));
            if (type28data) {
              setTimeout(() => {
                this.$store.dispatch("updateCollegeTime", type28data);
                localStorage.setItem("type28Data", "");
              }, 1000);
            }
          }
        } else {
          this.tree.nodes = [];
          this.$store.state.college.collegeTreeData = [];
        }
        this.loading = false;
      } else {
        this.$message.error(response.desc);
      }

      function arraySort(temp) {
        for (let index = 0; index < temp.length; index++) {
          if (temp[index].nodes) {
            arraySort(temp[index].nodes);
          }
        }
        temp.sort((a, b) => {
          // 首先按 type 排序，type=2 的同事排在前面
          if (a.type !== b.type) {
            if (a.type === 2) return -1;
            if (b.type === 2) return 1;
          }
          // 如果 type 相同，再按原有的 sort 字段排序
          return b.sort - a.sort;
        });
      }
    },

    setAdapterAction2(isSet) {
      console.log("clientList setAdapterAction2 isSet = ", isSet);
      if (isSet === true) {
        //从节点中删除人员
        this.adapterRemove();
      }
    },
    changeQuick(source) {
      // source 存在 改变发送的值；不存在 更换选中的同事
      console.log("source-------", source);
      if (source) {
        this.$emit("changeQuick", source);
      } else {
        this.$emit("changeQuick", "");
      }
    },

    adapterRemove() {
      console.log("clientList adapterRemove");
      var data = this.$store.state.college.nowSelectClient;
      console.log("clientList adapterRemove data = ", data);
      console.log("clientList adapterRemove last = ", data);
      var sessionList = data.nodes;
      if (sessionList !== null) {
        for (var i = 0; i < sessionList.length; i++) {
          const session = sessionList[i];
          if (session.cid === data.cid && session.sid === data.sid) {
            sessionList.splice(i, 1);
          }
        }
      }
    },

    async contactsRequest(clickTime) {
      // (1：浏览中，2：会话中，3：已离开，4：骚扰，5.对话过0:查询所有)
      let csid;
      if (this.$store.state.currentColleageInfo === null) {
        csid = JSON.parse(localStorage.getItem("account")).id;
      } else {
        csid = this.$store.state.currentColleageInfo.id;
      }
      this.getConversationing({ csid, clickTime });
      // this.getBrowsings({csid, current:1,clickTime});
      this.getConversationed({ csid, clickTime });
      this.getLeaveList({ csid, clickTime });

      if (this.$store.state.authority.isColleague) {
        this.getCountRequest(csid);
      }
    },
    async commonRequest({ api, type, csid, clickTime = null, current }) {
      console.log(
        "新的=====csid:",
        csid,
        "当前账号id:",
        JSON.parse(localStorage.getItem("account")).id,
        "当前页码current:"
        // current
      );
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          type: type,
          csid: csid,
          clickTime: clickTime,
          current: current,
          size: "null",
          accountCsid: this.util.getLocalAccount().id,
        },
      });
      if (response.resultCode !== "10000") {
        this.$message.error(response.desc);
        return;
      }
      if (response.data.clickTime === this.clickTime) {
        return response.data;
      } else {
        return;
      }
    },
    // 对话中列表
    async getConversationing({ csid, clickTime }) {
      var resdic = await this.commonRequest({
        api: "/manager/session/customer/talkinglist",
        type: 2,
        csid: csid,
        clickTime,
      });
      console.log("对话中列表-------:", resdic);
      if (resdic && resdic.talkings !== null) {
        for (var i = 0; i < resdic.talkings.length; i++) {
          var talk = resdic.talkings[i];
          talk.isChecked = false;
          talk.isNew = false;
          if (talk.unread_msg_count > 0) {
            talk.isFlicker = true;
          } else {
            talk.isFlicker = false;
          }
        }
        if (csid === this.util.getLocalAccount().id) {
          this.$store.state.talkingList = resdic.talkings;
        } else {
          this.$store.state.cstalkingList = resdic.talkings;
        }
        // this.$store.state.talkingList = resdic.talkings;
      } else {
        console.log("会话中列表:", this.$store.state.talkingList);
        if (csid === this.util.getLocalAccount().id) {
          this.$store.state.talkingList = [];
        } else {
          this.$store.state.cstalkingList = [];
        }
        this.util.pauseFlickerAudio();
      }
    },
    // 浏览中列表
    async getBrowsings({ csid, current, clickTime }) {
      var resdic = await this.commonRequest({
        api: "/manager/session/customer/browsingList",
        type: 1,
        csid: csid,
        current: current,
        clickTime,
      });
      if (current === 1) {
        if (resdic && resdic.browsings !== null) {
          for (let m = 0; m < resdic.browsings.length; m++) {
            let browser = resdic.browsings[m];
            browser.isChecked = false;
            browser.isFlicker = false;
            browser.isNew = false;
            browser.canOperate = true;
          }
          if (csid === this.util.getLocalAccount().id) {
            this.$store.state.browserList = resdic.browsings;
          } else {
            this.$store.state.csbrowserList = resdic.browsings;
          }
        } else {
          if (csid === this.util.getLocalAccount().id) {
            this.$store.state.browserList = [];
          } else {
            this.$store.state.csbrowserList = [];
          }
        }
      } else {
        if (resdic && resdic.browsings !== null) {
          for (let m = 0; m < resdic.browsings.length; m++) {
            let browser = resdic.browsings[m];
            browser.isChecked = false;
            browser.isFlicker = false;
            browser.isNew = false;
            browser.canOperate = true;
            if (csid === this.util.getLocalAccount().id) {
              this.$store.state.browserList.push(resdic.browsings[m]);
            } else {
              this.$store.state.csbrowserList.push(resdic.browsings[m]);
            }
          }
        }
      }

      if (resdic.currentPage >= resdic.totalPage) {
        console.log("浏览中列表数据查询完");
        console.log("resdic:===", resdic, resdic.currentPage);
        return;
      } else {
        console.log("浏览中列表数据查询++");
        this.getBrowsings(csid, ++resdic.currentPage);
      }
    },
    // 会话过列表
    async getConversationed({ csid, clickTime }) {
      var resdic = await this.commonRequest({
        api: "/manager/session/customer/talkedList",
        type: 5,
        csid: csid,
        clickTime,
      });
      if (resdic && resdic.talked !== null) {
        for (var i = 0; i < resdic.talked.length; i++) {
          var talk = resdic.talked[i];
          talk.isChecked = false;
          talk.isNew = false;
          talk.isFlicker = false;
          talk.canOperate = false;
        }
        if (csid === this.util.getLocalAccount().id) {
          this.$store.state.talkedList = resdic.talked;
        } else {
          this.$store.state.cstalkedList = resdic.talked;
        }
        console.log("this.$store.commonstate.会话过:====", resdic.talked);
        console.log(
          "this.$store.state.talkedList",
          this.$store.state.talkedList
        );
        // } else {
        //   if (this.$store.state.currentColleageInfo === null) {
        //     this.$store.state.talkedList = [];
        //   } else {
        //     this.$store.state.cstalkedList = [];
        //   }
      } else {
        if (csid === this.util.getLocalAccount().id) {
          this.$store.state.talkedList = [];
        } else {
          this.$store.state.cstalkedList = [];
        }
      }
    },

    // 在线列表
    async getOnlineList() {
      var api = "/manager/allsession/getlist";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("clientList getOnlineList response = ", response);
      if (response.resultCode !== "10000") {
        this.$message.error(response.desc);
        return;
      }

      let nonOpenList = response.data.nonOpenList;
      if (nonOpenList != null && nonOpenList.length > 0) {
        for (let i = 0; i < nonOpenList.length; i++) {
          var nonOpen = nonOpenList[i];
          nonOpen.isChecked = false;
          nonOpen.isFlicker = false;
          nonOpen.isNew = false;
          nonOpen.canOperate = false;
        }
        this.$store.state.onlineList = nonOpenList;
      } else {
        this.$store.state.onlineList = [];
      }
      console.log("线上列表：", nonOpenList);
    },

    // 在线列表
    async getOnlineOffList() {
      var api = "/manager/allsession/getLeaveNoEndList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("clientList getOnlineOffList response = ", response);
      if (response.resultCode !== "10000") {
        this.$message.error(response.desc);
        return;
      }

      let getLeaveNoEndList = response.data.getLeaveNoEndList;
      if (getLeaveNoEndList != null && getLeaveNoEndList.length > 0) {
        for (let i = 0; i < getLeaveNoEndList.length; i++) {
          var nonOpen = getLeaveNoEndList[i];
          nonOpen.isChecked = false;
          nonOpen.isFlicker = false;
          nonOpen.isNew = false;
          nonOpen.canOperate = false;
        }
        this.$store.state.onlineOffList = getLeaveNoEndList;
      } else {
        this.$store.state.onlineOffList = [];
      }
      console.log("已离开（未结束）：", getLeaveNoEndList);
    },

    // 已离开列表
    async getLeaveList({ csid, clickTime }) {
      let paramValue = localStorage.getItem("getLeavedList");
      paramValue = paramValue ? paramValue : null;
      console.log("getLeaveList paramValue:", paramValue);
      var res = await this.util.postRequest({
        url: "/manager/session/customer/leavelist",
        method: "POST",
        data: {
          type: 3,
          csid: csid,
          current: null,
          size: "null",
          accountCsid: this.util.getLocalAccount().id,
          paramValue,
          clickTime,
        },
      });

      console.log("getLeaveList res:", res);

      if (res.data.clickTime !== this.clickTime) {
        return;
      }
      let resdic = res.data;

      if (resdic && resdic.leaves !== null) {
        // console.log("resdic.leaves", resdic.leaves.length);
        for (var n = 0; n < resdic.leaves.length; n++) {
          const leaver = resdic.leaves[n];
          leaver.isChecked = false;
          leaver.isFlicker = false;
          leaver.isNew = false;
          leaver.hasLeaved = true;
          leaver.canOperate = false;
        }
        if (csid === this.util.getLocalAccount().id) {
          console.log("getLeaveList-----: 有数据  自己的已离开列表");
          this.$store.state.leavedList = resdic.leaves;
        } else {
          console.log("getLeaveList-----: 有数据  同事的已离开列表");
          this.$store.state.csleavedList = resdic.leaves;
        }
      } else {
        if (csid === this.util.getLocalAccount().id) {
          console.log("getLeaveList-----: 无数据  自己的已离开列表");
          this.$store.state.leavedList = [];
        } else {
          console.log("getLeaveList-----: 有数据  同事的已离开列表");
          this.$store.state.csleavedList = [];
        }
      }
      if (resdic.leaves) {
        this.$store.state.maxLeaveNum = resdic.leaves.length;
      } else {
        this.$store.state.maxLeaveNum = 0;
      }
    },
    // 骚扰列表
    async getHarass(csid) {
      const api = "/manager/session/customer/harassList";
      const resdic = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          type: 4,
          csid: csid,
          // clickTime: clickTime,
          current: null,
          size: "null",
          accountCsid: this.util.getLocalAccount().id,
        },
      });
      if (resdic.resultCode !== "10000") {
        this.$message.error(resdic.desc);
        return;
      }
      const res = resdic.data;
      console.log("resdicresdicresdicresdicresdicresdicresdicre:sdic", resdic);
      if (res.harass !== null) {
        for (var b = 0; b < res.harass.length; b++) {
          var harass = res.harass[b];
          harass.isChecked = false;
          harass.isFlicker = false;
          harass.canOperate = false;
          harass.isNew = false;
          // harass.gender = this.util.changeGender(harass.gender)
        }
        this.$store.state.troubleList = res.harass;
      } else {
        this.$store.state.troubleList = [];
      }
    },

    clickItem(obj) {
      const selected = this.$store.state.selectedClient;
      console.log("clientList clickItem selected = ", selected);
      console.log("clientList clickItem obj = ", obj);
      console.log("keyname = ", this.$store.state.keyName);
      // console.log(this.$store.state.college.nowSelectClient);
      // if (this.$store.state.college.nowSelectClient === null) {
      //   this.$store.state.college.nowSelectClient.os = "0";
      // }
      // obj.isFlicker = false;
      //if (this.$store.state.colleageAngle) {
        this.$store.state.college.nowSelectClient = obj;
      //}
      this.isWork = false;
      var item = obj;
      item.unread_msg_count = "0";
      this.itemObj = item;
      this.$store.commit("chooseClient", item);
      // this.util.removeLocalFlicker(item);
      console.log(
        "clientList clickItem client = ",
        this.$store.state.selectedClient
      );
      console.log(
        "clientList clickItem college = ",
        this.$store.state.college.nowSelectClient
      );

      var isPauseNew = true;
      for (var i = 0; i < this.$store.state.talkingList.length; i++) {
        const newObj = this.$store.state.talkingList[i];
        if (newObj.isNew === true) {
          isPauseNew = false;
          break;
        }
      }
      if (isPauseNew === true) {
        this.util.pauseNewAudio();
      }

      var isPauseFlicker = true;
      for (var j = 0; j < this.$store.state.talkingList.length; j++) {
        const flickerObj = this.$store.state.talkingList[j];
        if (flickerObj.isFlicker === true) {
          isPauseFlicker = false;
          break;
        }
      }
      if (isPauseFlicker === true) {
        this.util.pauseFlickerAudio();
      }

      //this.tempColleague = obj.csid;
      this.sendType7(obj.csid, 1);
      if(this.$store.state.keyName === "在线访客列表")
         this.sendTyp8(obj,1);
    },

    clickCollege(obj) {
      console.log("clientList clickCollege obj = ", obj);
      const selected = this.$store.state.college.nowSelectClient;
      console.log("clientList clickCollege selected = ", selected);
      console.log("clientList clickCollege obj = ", obj);
      console.log("keyname = ", this.$store.state.keyName);
      if (this.$store.state.selectedClient !== null) {
        this.$store.state.selectedClient.isChecked = false;
        this.$store.state.selectedClient = null;
      }
      this.isWork = false;
      var item = obj;
      item.unread_msg_count = "0";

      this.itemObj = item;

      this.$store.commit("chooseSession", item);

      console.log(
        "clientList clickCollege client ",
        this.$store.state.selectedClient
      );
      console.log(
        "clientList clickCollege college = ",
        this.$store.state.college.nowSelectClient
      );
    },

    setTreeNode() {
      const nodeList = [
        {
          name: "客服一部",
          id: "001",
          type: "1", //1-部门, 2-人员 3-访客 4-根节点(我的同事)
          nodes: [
            {
              name: "市场部01",
              id: "101",
              type: "1",
              nodes: [
                {
                  name: "王宏亮",
                  id: "101",
                  type: "2",
                  status: "1", //在线状态：1-在线 2-忙碌 0-离开
                  nodes: [
                    {
                      name: "游客01-01",
                      id: "101",
                      type: "3",
                      isChecked: false,
                    },
                  ],
                },
              ],
            },
            {
              name: "孙七",
              id: "101",
              type: "2",
              status: "0",
            },
            {
              name: "赵六",
              id: "101",
              type: "2",
              status: "2",
              nodes: [
                {
                  name: "游客01",
                  id: "108",
                  type: "3",
                  isChecked: false,
                },
                {
                  name: "游客02",
                  id: "109",
                  type: "3",
                  isChecked: false,
                },
              ],
            },
          ],
        },
        {
          name: "客服部二部",
          id: "001",
          type: "1", //1-部门, 2-人员 3-访客
          nodes: [
            {
              name: "客服01",
              id: "101",
              type: "2",
              status: "1",
              isChecked: false,
            },
          ],
        },
      ];

      return nodeList;
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.client_container {
  // width: 80%;
  height: 100vh;
  display: flex;
  /* background: #FFFFFF; */
  background-color: #f7fbf7;
  padding-left: var(--sidebar-w, 57px);
  box-sizing: border-box;
}
.common-avatar {
  border-radius: 0.25rem;
  width: 1.85rem;
  height: 1.85rem;
  vertical-align: middle;
  position: relative;
}

.mydia_div {
  /* 固定宽度，不随窗口/拖拽缩放 */
  flex: 0 0 var(--mydia-w, 150px);
  width: var(--mydia-w, 150px);
  min-width: var(--mydia-w, 150px);
  max-width: var(--mydia-w, 150px);
  box-sizing: border-box;
  border-right: 0.25rem #e2e8f0 solid;
  float: left;
  height: 100%;
  background-color: #f9f9f9;
  position: relative;
  overflow: hidden;
  .mydia_div_header {
    display: flex;
    align-items: center;
    justify-items: start;
    background-color: #fff;
    padding: 8px 6px;
    box-sizing: border-box;
    cursor: pointer;
    span {
      margin-left: 8px;
      color: #333333;
      @include change_title_size($title_size_normal);
      font-size: 14px !important;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
    .mydia_header_info {
      margin-left: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-width: 0;
    }
    .mydia_header_title {
      margin-left: 0;
      line-height: 1.2;
    }
    .mydia_header_status {
      margin-top: 2px;
      @include change_tip_size($tip_size_normal);
      font-size: 11px !important;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      line-height: 1.2;
      white-space: nowrap;
    }
  }

  .aside_div_icon {
    width: 14px;
    height: 14px;
    margin-right: 2px;
  }
  .mydiaTree-department {
    margin-top: 2px;
    .mydiaTree-department-colleage {
      display: flex;
      // padding-left: 20px;
      background-color: #f7fbf7;
      cursor: pointer;
      &:hover {
        background-color: #e6f0fe;
      }
      .mydiaTree-department-colleage-diaNum {
        @include change_tip_size($tip_size_normal);
        position: absolute;
        text-align: center;
        background-color: #1577d2;
        right: 0;
        transform: translateX(10%);
        color: #fff;
        top: 0;
        white-space: nowrap;
        border-radius: 50%;
        min-width: 20px;
        min-height: 20px;
        padding: 2px;
        line-height: 1;
        box-sizing: content-box;
        &:before {
          content: "";
          display: inline-block;
          vertical-align: middle;
          padding-top: 100%;
          height: 0;
        }
        & > span {
          display: inline-block;
          vertical-align: middle;
        }
      }
      .mydiaTree-department-colleage-text {
        padding: 10px 0px;
        border-bottom: 1px dashed #ddd;
        display: flex;
        flex: 1;
        justify-content: space-between;
        flex-direction: column;
        margin-left: 8px;
        img {
          width: 10px;
          height: 14px;
          vertical-align: middle;
        }
      }
    }
  }

  .el-collapse :deep() {
    .el-collapse-item__header {
      height: 36px;
      color: #333;
      background-color: #f1f1f1;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;
      @include change_size($font_size_normal);
    }
    .el-collapse-item__content {
      padding-bottom: 0;
      @include change_size($font_size_normal);
    }
    .el-collapse-item__arrow {
      display: none;
    }
  }
}

.menu_div {
  // width: 20%;
  // 原 flex:4，减少三分之一 → 与聊天区保持 8:39
  flex: 8;
  height: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  float: left;
  background-color: #fff;

  .menu_div_title {
    position: relative;
    & > div {
      width: 100%;
      box-sizing: border-box;
      padding: 0 10px 0 32px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .telescoping-img {
      width: 24px;
      height: 24px;
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      left: 4px;
      cursor: pointer;
    }
    .telescoping-img1 {
      transform: translateY(-50%) rotate(-180deg);
    }
    .telescoping-img2 {
      transform: translateY(-50%);
    }
  }
}

.menu_div::-webkit-scrollbar {
  display: none;
}
.menu_div_title {
  @include change_size($font_size_normal);
  text-align: center;
  background-color: #f1f1f1;
  padding: 10px 0;
  color: #1577d2;
  height: 40px;
  line-height: 20px;
  box-sizing: border-box;
}

.clientlist_div {
  width: 30%;
  height: 100%;
  overflow: scroll;
  background: #fc427b;
}

.el-menu-vertical-demo {
  width: 100%;
  height: 100%;
  text-align: left;
  border-right: 0;
}

.menu_icon {
  width: 1rem;
  height: 1.125rem;
  margin-right: 0.625rem;
}

.item_div,
.new_div {
  width: 100%;
  /* height: 100%; */
  height: 7.5rem;
  background: chartreuse;
}

.item_selected {
  background: #f2f7ff;
}

.new_div {
  background: #feeecd;
}

.chat_mainbox {
  // width: 65%;
  // 原 flex:13，配合会话列表减少三分之一后为 39
  flex: 39;
  overflow-x: auto;
  height: 100%;
  min-height: 0;
  background-color: #fff;
  border-left: 0.25rem #e2e8f0 solid;
  border-right: 0.25rem #e2e8f0 solid;
  /* border-left: 0.25rem #FFFFFF solid;
		border-right: 0.25rem #FFFFFF solid; */
  box-sizing: border-box;
  display: block;
  float: left;
}

.checked_back {
  width: 0.25rem;
  height: 100%;
  background: #5a9cf8;
  position: absolute;
  left: 0;
}

.tree_box {
  /* background-color: yellow; */
  width: 100%;
  max-height: 18.75rem;
  overflow: scroll;
  /* height: 25rem; */
  /* overflow-y: hidden; */
}

.tree_box::-webkit-scrollbar {
  display: none;
}

.tree_div {
  margin-left: 2.8125rem;
  width: 95%;
  /* background: greenyellow; */
  margin-left: 0.5rem;
}

.custom-tree-node {
  /* background-color: orange; */
  /* height: 3.125rem; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  /* padding-right: 8px; */
}

/* :deep() .el-tree-node__label {
		font-size: 12px;
		background-color: orchid;
	} */

.tree_lb {
  /* background-color: yellow; */
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  overflow: scroll;
  text-overflow: ellipsis;
  max-width: 7.5rem;
}

:deep() .el-tree-node__content {
  height: 3.125rem;
  /* background-color: orange; */
  /* margin:0.3125rem; */
}

/* :deep() .el-menu-item {
		height: 100px;
		line-height: 90px;
		background: yellow;
		margin-bottom: 0.625rem;
	} */

.el-menu-vertical-demo :deep() .el-menu-item {
  height: 90px;
  line-height: 5.625rem;
  background: #f8f8f8;
  margin-bottom: 0.375rem;
}

/* :deep() .el-submenu__title{
		height: 90px;
		line-height: 90px;
	} */

.icon_div {
  width: 3.125rem;
  line-height: 100%;
  /* background-color: rgba(68, 68, 68, 0.0); */
  /* background-color: greenyellow; */
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: 0;
  /* justify-content: flex-start; */
  /* margin-left: 5%;
		margin-right: 7%; */
}

.device_div,
.brower_div {
  width: 14px;
  height: 14px;
  /* background-color: #D6A2E8; */
  margin-right: 0.375rem;
}
.twinkling {
  -webkit-animation: twinkling 1s infinite ease-in-out;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes twinkling {
  0% {
    opacity: 0; 
  }

  100% {
    opacity: 1; 
  }
}

@keyframes twinkling {
  0% {
    opacity: 0; 
  }

  100% {
    opacity: 1; 
  }
}

// @-webkit-keyframes twinkling {
//   0% {
//     background-color: #fff;
//   }

//   100% {
//     background-color: #ffe464;
//   }
// }

// @keyframes twinkling {
//   0% {
//     background-color: #fff;
//   }

//   100% {
//     background-color: #ffe464;
//   }
// }

html[data-compact="1"] {
  .client_container {
    padding-left: var(--sidebar-w, 43px);
  }
  .mydia_div {
    flex: 0 0 var(--mydia-w, 116px);
    width: var(--mydia-w, 116px);
    min-width: var(--mydia-w, 116px);
    max-width: var(--mydia-w, 116px);
  }
  /* 小屏略加宽「对话中/对话过」栏 */
  .menu_div {
    flex: 9;
    min-width: 160px;
  }
  .chat_mainbox {
    flex: 38;
    min-width: 0;
  }
  .common-avatar {
    width: 12px !important;
    height: 12px !important;
  }
  .mydia_div .mydia_div_header {
    padding: 4px 4px;
    span {
      margin-left: 4px;
      font-size: 11px !important;
    }
    .mydia_header_info {
      margin-left: 4px;
    }
    .mydia_header_title {
      margin-left: 0 !important;
    }
    .mydia_header_status {
      font-size: 9px !important;
    }
  }
  .menu_div_title {
    height: 28px;
    padding: 4px 0;
    line-height: 20px;
    font-size: 12px !important;
  }
  .menu_div_title .telescoping-img {
    width: 14px;
    height: 14px;
  }
}
</style>
